/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';

export default function VerticalTable({
  children, customDataTestID
}: Object): React.Element {
  return (
      <Table customDataTestID={customDataTestID} style={{
        border: '1px solid #e5e5e5',
        margin: '.25rem 0'
      }}>
        {children}
      </Table>
  );
}
